import React from 'react';

/** [CurveBeamAI] Logo URL - uses CurveBeamAI/assets/curvebeam-logo.png from public */
function getCurveBeamLogoUrl(): string {
  const base = (typeof window !== 'undefined' && (window as any).PUBLIC_URL) || '/';
  const normalized = base.endsWith('/') ? base : `${base}/`;
  return `${normalized}CurveBeamAI/assets/curvebeam-logo.png`;
}

/**
 * [CurveBeamAI] Logo component for header branding - uses official CurveBeam AI logo image.
 * Replaces Open Health Imaging Foundation logo in the top-left header.
 * Includes an investigational-use notice beside the logo.
 */
export const CurveBeamLogo = () => (
  <div className="flex items-end gap-1.5">
    <img
      src={getCurveBeamLogoUrl()}
      alt="CurveBeam AI"
      className="h-8 w-auto object-contain"
      draggable={false}
    />
    <div
      style={{
        backgroundColor: '#1a8fc4',
        width: '1px',
        height: '20px',
        marginBottom: '3px',
        marginLeft: '4px',
        marginRight: '4px',
      }}
    />
    <span
      className="text-[10px] font-bold leading-none tracking-wide"
      style={{ color: '#1a8fc4', marginBottom: '3px' }}
    >
      This viewer is for investigational use only
    </span>
  </div>
);

export default CurveBeamLogo;
